import { createReducer } from 'redux-act';

import {
  WEB_CONTENTS_FETCH, WEB_CONTENTS_FETCH_DATA_SUCCESS, WEB_CONTENTS_FETCH_DATA_FAIL,
  WEB_CONTENTS_DELETE_INIT, WEB_CONTENTS_DELETE_SUCCESS, WEB_CONTENTS_DELETE_FAIL,
  WEB_CONTENTS_CREATE_INIT, WEB_CONTENTS_CREATE_SUCCESS, WEB_CONTENTS_CREATE_FAIL,
  WEB_CONTENTS_MODIFY_INIT, WEB_CONTENTS_MODIFY_SUCCESS, WEB_CONTENTS_MODIFY_FAIL,
  WEB_CONTENTS_CLEAN_UP, WEB_CONTENTS_CLEAR_DATA_LOGOUT,
} from 'state/actions/webContents';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webContentsReducer = createReducer(
  {
    [WEB_CONTENTS_FETCH]: (state) => ({ ...state, loading: true, error: null }),
    [WEB_CONTENTS_FETCH_DATA_SUCCESS]: (state, payload) => ({ ...state, list: payload.list || [], loading: false }),
    [WEB_CONTENTS_FETCH_DATA_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error }),
    [WEB_CONTENTS_CREATE_INIT]: (state) => ({ ...state, loading: true, success: false }),
    [WEB_CONTENTS_CREATE_SUCCESS]: (state, payload) => ({ ...state, list: [...state.list, payload.content], loading: false, success: true }),
    [WEB_CONTENTS_CREATE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, success: false }),
    [WEB_CONTENTS_MODIFY_INIT]: (state) => ({ ...state, loading: true, updated: false }),
    [WEB_CONTENTS_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.map((item) => item._id === payload.id ? payload.content : item),
      loading: false, updated: true,
    }),
    [WEB_CONTENTS_MODIFY_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, updated: false }),
    [WEB_CONTENTS_DELETE_INIT]: (state) => ({ ...state, loading: true, deleted: false }),
    [WEB_CONTENTS_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((item) => item._id !== payload.id),
      loading: false, deleted: true,
    }),
    [WEB_CONTENTS_DELETE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, deleted: false }),
    [WEB_CONTENTS_CLEAN_UP]: (state) => ({ ...state, loading: false, error: null, success: false, deleted: false, updated: false }),
    [WEB_CONTENTS_CLEAR_DATA_LOGOUT]: () => ({ ...initialState }),
  },
  initialState
);
